<template>
  <div class="has-padding-30 flex-row justify-space-between align-items-center">
    <div class="is-size-5 has-text-black">
      Form Reference Number
      <br>
      <span class="has-text-weight-bold">{{shippingRequest.reference_number}}</span>
    </div>
    <div class>
      <!-- Approved -->
      <div v-if="status==='APPROVED'" class="has-max-width-400">
        <h2 class="is-size-5 has-text-weight-bold has-text-black is-uppercase has-letter-spacing-3 has-margin-bottom-20">
          STATUS -
          <span class="has-background-green is-white has-padding-10 status">{{status}}</span>
        </h2>
        <div class="buttons has-margin-top-20 is-left">
          Application is approved - 
          <a @click="printCertificate" class=" has-text-blue has-padding-left-5" style="text-decoration: underline;">Print Shipment Certificate</a>
        </div>
      </div>

      <!-- Awaiting Processing -->
      <div v-if="status==='AWAITING_PROCESSING'" class="has-max-width-350">
        <h2 class="is-size-5 has-text-black has-text-weight-bold is-uppercase">
          STATUS -
          <span
            class="has-background-yellow is-white has-padding-10 status"
          >{{displayStatus}}</span>
        </h2>
      </div>

      <!-- Failed Processing -->
      <div v-if="status==='FAILED_PROCESSING'" class="has-max-width-350">
        <h2 class="is-size-5 has-text-black has-text-weight-bold is-uppercase">
          STATUS -
          <span class="has-background-red is-white has-padding-10 status">{{displayStatus}}</span>
        </h2>
        <p v-if="shippingRequest.messages && shippingRequest.messages[0].action_type == 'NIMASA_REJECT'"
          class="has-margin-top-20">
          Reason for denial - {{shippingRequest.messages[0].message}}
        </p>
      </div>

      <!-- Pending Approval -->
      <div v-if="status==='PENDING_APPROVAL'" class="has-max-width-350">
        <h2 class="is-size-5 has-text-black has-text-weight-bold is-uppercase">
          STATUS -
          <span
            class="has-background-yellow is-white has-padding-10 status"
          >{{displayStatus}}</span>
        </h2>
      </div>

      <!-- Disapproved -->
      <div v-if="status==='DISAPPROVED'" class="has-max-width-350">
        <h2 class="is-size-5 has-text-black has-text-weight-bold is-uppercase">
          STATUS -
          <span class="has-background-red is-white has-padding-10 status">{{displayStatus}}</span>
        </h2>
        <p v-if="shippingRequest.messages && shippingRequest.messages[0].action_type == 'NIMASA_DISAPPROVE'"
          class="has-margin-top-20"
        >Rejection Message: {{shippingRequest.messages[0].message}}</p>
      </div>

      <!-- Completed -->
      <div v-if="status==='COMPLETED'" class="has-max-width-350">
        <h2 class="is-size-5 has-text-black has-text-weight-bold is-uppercase ">
          STATUS -
          <span
            class="has-background-black is-white has-padding-10 status"
          >{{status.replace("_", " ")}}</span>
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
import printer from "vue-printer";
import PrintCertificateModal from "./PrintCertificateModal";
export default {
  name: "status-information",
  props: {
    status: String,
    shippingRequest: Object
  },
  components: {
    printer,
    PrintCertificateModal
  },
  methods: {
    printCertificate: function() {
      this.$modal.open({
        parent: this,
        component: PrintCertificateModal,
        hasModalCard: true,
        props: {
          data: this.shippingRequest
        }
      });
    }
  },

  computed: {
    displayStatus: function() {
      switch (this.status) {
        case "PENDING_APPROVAL":
          return "PENDING APPROVAL";
          break;
        case "AWAITING_PROCESSING":
          return "PENDING APPROVAL";
          break;
        case "FAILED_PROCESSING":
          return "REJECTED";
          break;
        case "DISAPPROVED":
          return "REJECTED";
          break;

        default:
          break;
      }
    }
  }
};
</script>
<style scoped>
.status {
  border-radius: 4px;
}

button span {
  padding-left: 0 !important;
}
</style>

